import React from 'react'
import PropTypes from 'prop-types'
import AccordionItem from './item'

const Accordion = ({ activeIndex, items, onItemClick }) => {
   return (
      <div className="w-100">
         {items.map((item, index) => (
            <AccordionItem
               key={`accordion-item-${item.title}`}
               title={item.title}
               description={item.description}
               icon={item.icon}
               isOpen={activeIndex === index}
               onClick={() => onItemClick(index)}
            />
         ))}
      </div>
   )
}

Accordion.propTypes = {
   activeIndex: PropTypes.number,
   items: PropTypes.arrayOf(
      PropTypes.shape({
         title: PropTypes.string.isRequired,
         description: PropTypes.string.isRequired
      })
   ).isRequired,
   onItemClick: PropTypes.func.isRequired
}

Accordion.defaultProps = {
   activeIndex: null
}

export default Accordion
